type Versioned = {
	version: number;
};


const readVersionedLocalStorage = <T extends Versioned>(
	key: string,
	version: number,
	isValue: (value: unknown) => value is T,
	defaults: T,
): T => {
	const raw = localStorage.getItem(key);
	if (raw == null) {
		return defaults;
	}
	let data: unknown;
	try {
		data = JSON.parse(raw);
	} catch {
		return defaults;
	}
	if (isValue(data) && data.version === version) {
		return data;
	}
	return defaults;
};


const writeVersionedLocalStorage = <T extends Versioned>(
	key: string,
	version: number,
	read: () => T,
	patch: Partial<Omit<T, 'version'>>,
): void => {
	const conf = read();
	Object.assign(conf, patch);
	conf.version = version;
	localStorage.setItem(key, JSON.stringify(conf));
};


export {
	readVersionedLocalStorage,
	writeVersionedLocalStorage,
};
